// KD-3848 — the last assistant session of each product, shared across tabs:
// the Trip Designer adds a product in another tab than its factsheet. Sent
// with add-to-trip and add-to-basket events to measure the pilot, and joined
// with the API's assistant_exchanges log by session id.
const KEY = 'assistantSessions';
// ponytail: a page visit long ago is not what made the TO add the product.
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') ?? {};
  } catch {
    return {};
  }
};

export const rememberAssistantSession = (productType, productId, sessionId) => {
  try {
    const now = Date.now();
    const sessions = Object.fromEntries(
      Object.entries(read()).filter(([, s]) => now - s.at < MAX_AGE_MS),
    );
    sessions[`${productType}:${productId}`] = { sessionId, at: now };
    localStorage.setItem(KEY, JSON.stringify(sessions));
  } catch {
    // Private mode or full storage: tracking only, nothing to fix.
  }
};

/** The session id, or null when the TO did not use the assistant there. */
export const assistantSessionFor = (productType, productId) => {
  const session = read()[`${productType}:${productId}`];
  return session && Date.now() - session.at < MAX_AGE_MS
    ? session.sessionId
    : null;
};
